package com.vizio.redwolf.m2m.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class M2MFailureResponse(
    @SerialName("status") val status: String? = null,
    @SerialName("errorMessage") val errorMessage: String? = null,
)